module.exports = __webpack_public_path__ + "img/mianjianchanping.d86a3c93.png";